import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Element, Text } from "legacy/components/shared/base"
import AppStoreButtons from "legacy/components/shared/AppStoreButtons"

const DownloadApp: React.FC = (): React.ReactElement => {
  const { t } = useTranslation("shared", {
    keyPrefix: "footer",
  })

  return (
    <Element gridArea="download" mb={["60", "0"]} width="100%">
      <Text
        fontSize={["22", "22", "text.footerHeader"]}
        lineHeight={["28px", "28px", "normal"]}
        mb="10"
        textAlign={["center", "left"]}
        variant="footerHeader"
      >
        {t("download_app")}
      </Text>
      <Text
        color="white"
        fontFamily="martel"
        fontSize={["12", "15"]}
        lineHeight={["17px", "27px"]}
        mb={["25", "5"]}
        textAlign={["center", "left"]}
      >
        {t("standard_fees_apply")}
      </Text>
      <AppStoreButtons
        desktopAlignment="left"
        mobileAlignment="center"
        tabletAlignment="left"
        useQRCode={true}
      />
    </Element>
  )
}

export default DownloadApp
